module.exports = __webpack_public_path__ + "img/female-newborn-head.724d021e.svg";